import FormControl from './FormControl';

export default class FormControlWithBtnDisablingAndRecaptcha extends FormControl {
	constructor(formNode) {
		super(formNode);
		this.submitBtn = this.form.querySelector('.js-submit-form-btn');
	}

	onSubmit(event) {
		if (this.isFormValidationEnabled() && !this.validateForm()) {
			event.preventDefault();
		} else {
			this.disableButton.call(this);
			this.handleRecaptcha.call(this);
		}
	}

	disableButton() {
		if (this.submitBtn) {
			this.submitBtn.disabled = true;
			this.submitBtn.classList.add('btn--is-waiting');
		}
	}

	enableButton() {
		if (this.submitBtn) {
			this.submitBtn.disabled = false;
			this.submitBtn.classList.remove('btn--is-waiting');
		}
	}

	handleRecaptcha() {
		const recaptchaIframe = document.querySelector(
			'iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]',
		);
		if (
			!(
				recaptchaIframe &&
				recaptchaIframe.parentNode &&
				recaptchaIframe.parentNode.parentNode
			)
		) {
			return Promise.reject(new Error('Google reCaptcha DOM usage changed'));
		}
		const recaptchaContainer = recaptchaIframe.parentNode.parentNode;

		return new Promise(resolve => {
			const observer = new MutationObserver(() => {
				if (recaptchaContainer && recaptchaContainer.style.opacity === '0') {
					this.enableButton();
					resolve(true);
				}
			});
			observer.observe(recaptchaContainer, {
				attributes: true,
				attributeFilter: ['style'],
			});
		});
	}
}
